import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AmparosComponent} from '../amparos.component'
//Services
import {ProtectionService} from 'src/app/core/services/parameters/protection.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'edit-modal',
  templateUrl: './edit-modal.html',
  styleUrls: ['./edit-modal.component.scss']
})
export class EditarAmparoModal implements OnInit {

  editProtectionForm: FormGroup;
  loading = false;
  showAlert = false;
  protectionId;
  protectionData = {
    id: '',
    createdAt: ''
  };

  constructor(
    public dialogRef: MatDialogRef<AmparosComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private protectionService: ProtectionService
  ) {
  }

  ngOnInit(): void {
    this.editProtectionForm = this.fb.group({
      protection: [, Validators.required]
    })
    this.protectionId = this.data.id;
    this.protectionService.getProtectionById(this.protectionId).subscribe(_res => {
      this.protectionData = _res;
      this.editProtectionForm.patchValue({
        protection: _res.name
      })
    });
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.editProtectionForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.editProtectionForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.protection
      }
      this.protectionService.updateProtection(this.protectionId, data).subscribe(_res => {
        this.alert.setNotice('Amparo actualizado correctamente', 'success');
        this.showAlert = true;
        this.loading = false;
        setTimeout(() => this.onNoClick(true), 1000);
      }, _err => {
        this.alert.setNotice('No se pudo actualizar el amparo', 'danger');
        this.showAlert = true;
        this.loading = false;
      })
    } else {
      this.loading = false;
    }
  }

}
